var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 20,
    viewBox: "0 0 38 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1667 0.832031H9.83342C4.77341 0.832031 0.666748 4.9387 0.666748 9.9987C0.666748 15.0587 4.77341 19.1654 9.83342 19.1654H28.1667C33.2267 19.1654 37.3334 15.0587 37.3334 9.9987C37.3334 4.9387 33.2267 0.832031 28.1667 0.832031ZM9.83342 15.4987C6.79008 15.4987 4.33341 13.042 4.33341 9.9987C4.33341 6.95536 6.79008 4.4987 9.83342 4.4987C12.8767 4.4987 15.3334 6.95536 15.3334 9.9987C15.3334 13.042 12.8767 15.4987 9.83342 15.4987Z",
    fill: "#7EE494"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchActive);
export default __webpack_public_path__ + "static/media/switch-active.06d99c2280c9c20505947af72d72bff3.svg";
export { ForwardRef as ReactComponent };